export default "__VITE_ASSET__d8c95a2a__"